import { useState } from 'react';
import { useDispatch } from "react-redux";
import { Grid } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Alert from '@material-ui/lab/Alert';
import CreateCancel from "../../atoms/buttons/CreateCancel";
import { toggleRightDrawer, invokePostFileService, handleTopRightInfo, handleSnackBar, setTabOnFocus } from "../../../store/global/actions";
import ImportMessageComparisonTable from './ImportMessageComparisonTable';

const useStyles = makeStyles({
    fieldForm: {
        // marginLeft: -12
    },
    textCapitalise: {
        textTransform: 'capitalize'
    }
});




export default function ImportMessage({ }) {
    const classes = useStyles();
    const dispatch = useDispatch()

    const [file, setFile] = useState("");
    const [error, setError] = useState("");
    const [isCreating, setIsCreating] = useState(false);
    const [validFile, setInvalidFile] = useState(false);
    const [fileData, setFileData] = useState('')
    const [fileType, setFileType] = useState('')
    const [showConflicts, setShowConflicts] = useState(false);
    const [conflictData, setConflictData] = useState('')


    const isValidFile = (file) => (file?.type === "application/json" || file?.type === "application/x-ruby");


    const handleFileSelection = (e) => {
        setFile(e?.target?.files[0]?.name ? e?.target?.files[0]?.name : '');
        setFileData(e?.target?.files[0] ? e?.target?.files[0] : "")
        setFileType(e?.target?.files[0]?.type ? e?.target?.files[0]?.type : "")

        let isValid = isValidFile(e?.target?.files[0]);

        if (!isValid) {
            setError("Please upload a json/rb file (.json/.rb)");
        } else {
            setError("");
        }
    };

    const onImportMessages = () => {
        if (file === '') {
            setError('Please select a file');
            return;
        }

        setIsCreating(true)

        let formData = new FormData()
        formData.append('eventTypesFileName', file)
        formData.append('eventTypesFile', fileData)
        formData.append('fileType', fileType)
        dispatch(handleTopRightInfo({ message: "Importing messages...", open: true, }));



        dispatch(invokePostFileService('importEventTypes', formData, []))
            .then(async (result) => {
                dispatch(handleTopRightInfo({}));
                if (result.status == true && result.conflictStatus == false) {
                    dispatch(setTabOnFocus(0));
                    dispatch(handleSnackBar({ open: true, message: result.message, severity: 'success' }));
                }
                else if (result.status == true && result.conflictStatus == true) {
                    setConflictData(result.data)
                    setShowConflicts(true)
                }
                else {
                    setFile('')
                    dispatch(setTabOnFocus(0));
                    dispatch(handleSnackBar({ open: true, message: result.message ? result.message : "Something went wrong", severity: 'error' }));
                }

                // if (result?.data?.excluded && result?.data?.excluded.length > 0) {
                //     setFile('')
                //     setError(`Could not import ${result?.data?.excluded.join(',')} event types. These event types already exists.`)
                // }
                // else if (result?.data?.error) {
                //     setFile('')
                //     setError(result?.data?.error)
                // }
                setIsCreating(false);

            })
            .catch(error => console.error(error));

    }

    const onCompletion = () => {
        setShowConflicts(false);
        dispatch(setTabOnFocus(0));
    }

    const onCancel = () => {
        dispatch(toggleRightDrawer());
    }

    return (
        <Grid container direction={"row"} spacing={2}>

            <Grid item xs={12}>
                <Alert severity={!error ? "info" : "error"} icon={false}>{error == "" ? 'Upload a JSON/.rb file' : error}</Alert>

            </Grid>
            <Grid item xs={6}>
                <Button variant="contained" component="label" color="primary" className={classes.textCapitalise}>
                    Upload the file
                    <input type="file" hidden onChange={(e) => handleFileSelection(e)} />
                </Button>
            </Grid>

            <Grid item xs={3}>
                {file != "" && <Box color="text.primary">{file}</Box>}
            </Grid>

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }} >
                <CreateCancel onCreate={onImportMessages} onCancel={onCancel} createDisable={(isCreating || error != "") ? true : false} content={isCreating ? 'Importing..' : 'Import'} />
            </Grid>

            {showConflicts && <ImportMessageComparisonTable onClose={() => setShowConflicts(false)} onCompletion={onCompletion} data={conflictData.fields} tempDoc={conflictData.tempDoc} />}



        </Grid>
    )

}